<template>
    <div>
       
        <reg/>
    </div>
</template>
<script>
import reg from '@/components/Registercust'
export default {
     components: {      
        reg
     },
    
     data: () => ({
            name: 'Register',
            
      }),
      mounted(){
           this.$parent.$children[0].$parent.ttlval = this.name
      }
}
</script>
<style scoped>

</style>